import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  InputAdornment,
  FormControlLabel,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableBody,
  Dialog,
  DialogContent,
  Paper,
  Box,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Card, Tag, Typography as typography_antd } from "antd";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import ApplyLeaveStyle from "../../Components/ApplyLeaveStyle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchUserData } from "../../redux/slice/userData";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import env from "../../config/env";
import ModalImage from "react-modal-image";
import { ArrowUpwardRounded, OpenInFull, PictureAsPdf } from "@mui/icons-material";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ViewIdentityProof from "./ViewIdentityProof";

const { Title } = typography_antd;
function ViewEmployee() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openIP, setOpenIP] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenIP = () => setOpenIP(true);
  const handleCloseIP = () => setOpenIP(false);

  const location = useLocation();
  const { viewUserData, leaveSummaryData } = location.state;
  console.log(viewUserData, "viewUserData");

  useEffect(() => {
    setLoading(false)
  }, [location])

  const leaveHandler = () => {
    navigate("/allemployee");
  };

  // // View File
  //   const uploadedFileUrl = '/path/to/upload.pdf'
  //   const handleViewFile = ()=>{
  //     window.open(uploadedFileUrl,'_self');
  //   }

  return (
    <ApplyLeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bordered={false}
          bodyStyle={{ height: "calc(100vh - 80px)", overflow: "auto" }}
          style={{
            margin: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <ArrowBackIcon
              onClick={leaveHandler}
              style={{
                fontSize: "22px",
                color: "#244DA0",
              }}
            />
            <div
              style={{
                display: "flex",
                marginTop: "3px",
                paddingLeft: "20px",
              }}
            >
              <Title
                level={2}
                style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
              >
                View Employee
              </Title>
            </div>
          </div>

          {!loading ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                <Typography className="label_text_profile profile-picture" >
                  Profile Picture
                  {/* <span style={{ color: "red" }}>*</span>{" "} */}
                </Typography>

                {viewUserData?.profile_pic ? (
                  <div
                    style={{
                      height: "95px",
                      width: "95px",
                      backgroundColor: "#8080805e",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      style={{
                        height: "95px",
                        width: "95px",
                        borderRadius: "50%",
                        border: "1px solid"
                      }}
                      src={`${env.backend_api_endpoint}/files/${viewUserData?.profile_pic}`}
                      alt={`${viewUserData?.profile_pic}`}
                    />
                  </div>
                ) : (
                  <Tag
                    style={{
                      borderRadius: "60px",
                      fontWeight: "bold",
                      border: "1px solid",
                      height: "95px",
                      width: "95px",
                      fontSize: "40px",
                      backgroundColor: "#c8e4fc",
                      color: "navy",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {viewUserData?.name?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")}
                  </Tag>
                )}

              </div>

              <div className="profileItem">
                <Title
                  level={4}
                  style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", marginBottom: "0px" }}
                >
                  Personal Details
                </Title>
                <div></div>

                <div>
                  <Typography className="label_text_profile">
                    Employee ID
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Employee ID"
                    value={viewUserData?.emp_id}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Name
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Name"
                    value={viewUserData?.name}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile" >
                    Designation
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Designation"
                    value={viewUserData?.designation}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Email
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Company Email"
                    value={viewUserData?.company_email}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Personal Email{" "}
                  </Typography>

                  <TextField
                    placeholder="Enter Personal Email"
                    autoComplete="off"
                    value={viewUserData?.personal_email}
                    fullWidth
                    disabled
                    size="small"
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Date Of Birth
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      disabled
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          inputProps: {
                            sx: {
                              padding: '11px 14px',
                              fontSize: '14px',
                            },
                          },
                          InputProps: {
                            sx: {
                              fontSize: '14px',
                              height: '40px',
                              '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                color: '#6b7280',
                                fill: '#6b7280',
                                opacity: 1,
                              },
                            },
                          },
                        },
                      }}

                      format="DD-MM-YYYY"
                      value={
                        viewUserData?.dob
                          ? dayjs(viewUserData?.dob)
                          : null
                      }
                    />
                  </LocalizationProvider>
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Joining Date
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      disabled
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: 'small',
                          inputProps: {
                            sx: {
                              padding: '11px 14px',
                              fontSize: '14px',
                            },
                          },
                          InputProps: {
                            sx: {
                              fontSize: '14px',
                              height: '40px',
                              '& .MuiButtonBase-root.Mui-disabled .MuiSvgIcon-root': {
                                color: '#6b7280',
                                fill: '#6b7280',
                                opacity: 1,
                              },
                            },
                          },
                        },
                      }}

                      format="DD-MM-YYYY"
                      value={
                        viewUserData?.joining_date
                          ? dayjs(viewUserData?.joining_date)
                          : null
                      }
                    />
                  </LocalizationProvider>
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Phone Number
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Phone Number"
                    fullWidth
                    disabled
                    size="small"
                    value={viewUserData?.phone_no}
                    type="number"
                    autoComplete="off"
                    sx={{
                      // target the root of the outlined input when it's disabled
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        paddingLeft: 0,
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"
                          sx={{
                            backgroundColor: '#f2f4f7',       // Light grey background
                            padding: '19px 12px',              // Padding for spacing
                            borderRight: '1px solid #ccc',    // Right border
                            borderTopLeftRadius: '4px',
                            borderBottomLeftRadius: '4px',
                            fontSize: '14px',
                            color: '#333',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >+91</InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Alternate Number
                  </Typography>
                  <TextField
                    placeholder="Enter Alternate Phone Number"
                    fullWidth
                    disabled
                    size="small"
                    type="number"
                    autoComplete="off"
                    sx={{
                      // target the root of the outlined input when it's disabled
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        paddingLeft: 0,
                      },
                    }}
                    value={viewUserData?.alternate_no}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"
                          sx={{
                            backgroundColor: '#f2f4f7',       // Light grey background
                            padding: '19px 12px',              // Padding for spacing
                            borderRight: '1px solid #ccc',    // Right border
                            borderTopLeftRadius: '4px',
                            borderBottomLeftRadius: '4px',
                            fontSize: '14px',
                            color: '#333',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >+91</InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div>
                  <Typography className="label_text_profile" >
                    Role
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Role"
                    value={viewUserData?.role_value}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile" >
                    Salary
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Designation"
                    value={viewUserData?.salary}
                    disabled
                    size="small"
                    fullWidth
                  />
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Adhar Card Number
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField placeholder="Adhar Card Number" type="number" disabled size="small" value={viewUserData?.aadhar_no} />
                </div>

                <div>
                  <div>
                    <Typography className="label_text_profile">
                      Identity Proof
                      {" "}
                    </Typography>
                  </div>
                  <Paper
                    variant="outlined"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "4px 14px",
                      borderRadius: 1,
                      // bgcolor:'#fafafa',
                      background: '#fff',
                      // borderColor:'#c4c4c4',
                      maxWidth: '100%',
                      // borderColor:"grey",
                      borderColor: "rgba(0,0,0,0.26)",

                    }}
                  >

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, }}>
                      <Typography
                        variant="body2"
                        sx={{ fontweight: 500, color: '#333', wordBreak: 'break-all', }}
                        onClick={handleOpenIP}
                      >
                        {`${viewUserData?.identity_pic}`}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={handleOpenIP}
                      sx={{ color: 'red' }}
                    >
                      <OpenInFullIcon fontSize="small" sx={{ color: '#6b7280' }} />
                    </IconButton>
                  </Paper>

                  {/* <img
                    style={{
                      height: "200px",
                      width: "200px",
                      marginTop: "0px",
                      marginLeft: "0px",
                      objectFit: "fill",
                    }}
                    src={
                      `${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`
                    }
                    alt={`${viewUserData?.identity_pic}`}
                    onClick={handleOpen} // Opens modal on click
                  /> */}

                  {/* Wrapper div to control image size */}
                  {/* <div
                    style={{
                      width: "200px",  // Set fixed width for small image
                      height: "200px", // Set fixed height for small image
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                  >
                    <ModalImage
                      small={`${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`}  // Small image (thumbnail)
                      large={`${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`}  // Full-size image in modal
                      alt="Identity Proof"
                      hideDownload
                      hideZoom
                    />
                  </div> */}

                </div>

                <div>
                  <Typography className="label_text_profile" >
                    Gender
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  {/* <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="radio-buttons-group"
                    disabled
                    size="small"
                    defaultValue={viewUserData?.gender}                   
                  >
                    <FormControlLabel
                      key="Male"
                      value="Male"
                      disabled
                      control={<Radio 
                        // className="customRD"
                      />}
                      label="Male"
                    />
                    <FormControlLabel
                      key="Female"
                      value="Female"
                      disabled
                      control={<Radio 
                         disabled
                          sx={{
                            // keep it fully opaque when disabled
                            '&.Mui-disabled': {
                              opacity: 1,
                            },
                            // unchecked + disabled → grey circle
                            '&.Mui-disabled:not(.Mui-checked)': {
                              color: 'rgba(0,0,0,0.6)',
                            },
                            // checked + disabled → primary blue circle
                            '&.Mui-disabled.Mui-checked': {
                              color: '#1976d2',
                            },
                          }}
                        // className="customRD"
                      />}
                      label="Female"
                    />
                  </RadioGroup> */}
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="radio-buttons-group"
                    disabled
                    size="small"
                    defaultValue={viewUserData?.gender}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontFamily: "Milliard",
                      },
                    }}
                  >
                    {['Male', 'Female'].map((gender) => (
                      <FormControlLabel
                        key={gender}
                        value={gender}
                        disabled
                        control={
                          <Radio
                            disabled
                            sx={{
                              // keep it fully opaque when disabled
                              '&.Mui-disabled': {
                                opacity: 1,
                              },
                              // unchecked + disabled {grey circle}
                              '&.Mui-disabled:not(.Mui-checked)': {
                                color: 'rgba(0,0,0,0.6)',
                              },
                              // checked + disabled {primary blue circle}
                              '&.Mui-disabled.Mui-checked': {
                                color: '#244DA0',
                              },
                            }}
                          />
                        }
                        label={gender}
                      />
                    ))}
                  </RadioGroup>
                </div>

                <div>
                  <Typography className="label_text_profile">
                    Address
                    {/* <span style={{ color: "red" }}>*</span>{" "} */}
                  </Typography>
                  <TextField
                    placeholder="Enter Address"
                    fullWidth
                    multiline
                    disabled
                    size="small"
                    value={viewUserData?.address}
                    rows={2}
                    autoComplete="off"
                  />
                </div>

                <div></div>

                {viewUserData.salary > 0 &&
                  <>
                    <Title
                      level={4}
                      style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", marginTop: "20px", marginBottom: "0px" }}
                    >
                      Bank Details
                    </Title>
                    <div></div>
                    <div>
                      <Typography className="label_text_profile">
                        Full Name
                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                      </Typography>
                      <TextField placeholder="Full Name" type="text" disabled size="small" value={
                        viewUserData?.first_name || viewUserData?.middle_name || viewUserData?.last_name
                          ? `${viewUserData?.first_name || ''} ${viewUserData?.middle_name || ''} ${viewUserData?.last_name || ''}`.trim()
                          : undefined
                      } />
                    </div>

                    <div>
                      <Typography className="label_text_profile">
                        Account Number
                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                      </Typography>
                      <TextField placeholder="Account Number" type="number" disabled size="small" value={viewUserData?.account_number ? viewUserData.account_number : undefined} />
                    </div>

                    <div>
                      <Typography className="label_text_profile">
                        Bank Name
                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                      </Typography>
                      <TextField placeholder="Bank Name" type="text" disabled size="small" value={viewUserData?.bank_name} />
                    </div>

                    <div>
                      <Typography className="label_text_profile">
                        Bank IFSC Code
                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                      </Typography>
                      <TextField placeholder="Bank IFSC Code" type="text" disabled size="small" value={viewUserData?.bank_ifsc} />
                    </div>

                    <div>
                      <Typography className="label_text_profile">
                        Branch Name
                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                      </Typography>
                      <TextField placeholder="Branch Name" type="text" disabled size="small" value={viewUserData?.branch_name} />
                    </div>

                    {/* Modal for Enlarged Image
                <Dialog open={open} onClose={handleClose} maxWidth="md">
                    <DialogContent style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
                      <img
                        src={`${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`}
                        alt="Identity Proof"
                        style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "10px" }}
                      />
                    </DialogContent>
                  </Dialog> */}
                  </>
                }

              </div>


              <div style={{ marginTop: "20px" }}>
                <Title
                  level={4}
                  style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
                >
                  Leave Summury
                </Title>
                {leaveSummaryData?.length > 0 ? (
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead className="table_Header_color">
                      <TableRow>
                        <TableCell>Leave Type</TableCell>
                        <TableCell>Days Assign</TableCell>
                        <TableCell>Days Taken</TableCell>
                        <TableCell>Leave Balance</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {leaveSummaryData?.map((row) => (
                        <TableRow
                          // key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>{row.leave_type}</TableCell>
                          <TableCell>{row.day_assign}</TableCell>
                          <TableCell>{row.day_taken}</TableCell>
                          <TableCell>{row.balance}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <p>No Leaves Assigned</p>
                )}
              </div>
            </>
          ) : (
            <span
              class="loader"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            />
          )
          }

          {/* {open && (
            <ModalImage
              small={`${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`}
              large={`${env.backend_api_endpoint}/files/${viewUserData?.identity_pic}`}
              alt="Identity Proof"
              onClose={() => setOpen(false)} // Close modal on click
            />
          )} */}

          <ViewIdentityProof
            open={openIP}
            handleCloseIP={handleCloseIP}
            title="Preview File"
            image={viewUserData?.identity_pic}
          />
        </Card >
      </div >
    </ApplyLeaveStyle >
  );
}

export default ViewEmployee;
